/* tslint:disable */
/* eslint-disable */
/**
 * Geocoding API
 * Telematics services geocoding API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddressStructuredType
 */
export interface AddressStructuredType {
    /**
     * 
     * @type {string}
     * @memberof AddressStructuredType
     */
    lang: string;
    /**
     * 
     * @type {string}
     * @memberof AddressStructuredType
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof AddressStructuredType
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof AddressStructuredType
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof AddressStructuredType
     */
    town: string;
    /**
     * 
     * @type {string}
     * @memberof AddressStructuredType
     */
    route: string;
    /**
     * 
     * @type {string}
     * @memberof AddressStructuredType
     */
    streetAddress: string;
    /**
     * 
     * @type {string}
     * @memberof AddressStructuredType
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof AddressStructuredType
     */
    source?: string | null;
}

export function AddressStructuredTypeFromJSON(json: any): AddressStructuredType {
    return AddressStructuredTypeFromJSONTyped(json, false);
}

export function AddressStructuredTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressStructuredType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lang': json['lang'],
        'address': json['address'],
        'countryCode': json['countryCode'],
        'country': json['country'],
        'town': json['town'],
        'route': json['route'],
        'streetAddress': json['street_address'],
        'postalCode': json['postalCode'],
        'source': !exists(json, 'source') ? undefined : json['source'],
    };
}

export function AddressStructuredTypeToJSON(value?: AddressStructuredType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lang': value.lang,
        'address': value.address,
        'countryCode': value.countryCode,
        'country': value.country,
        'town': value.town,
        'route': value.route,
        'street_address': value.streetAddress,
        'postalCode': value.postalCode,
        'source': value.source,
    };
}


